import { BRAND } from "@/lib/brand";

// Static legal page — Disclaimer & Copyright Notice. Fixed copy; not
// CMS-managed. Linked from the footer.
const Section = ({ title, children }) => (
  <section className="mt-10">
    <h2 className="font-serif text-2xl md:text-3xl text-ink mb-3">{title}</h2>
    <div className="space-y-3 text-ink_soft/85 font-light leading-relaxed">{children}</div>
  </section>
);

export default function DisclaimerPage() {
  const year = new Date().getFullYear();
  return (
    <div data-testid="page-disclaimer" className="bg-cream">
      <div className="container-page py-16 md:py-24 max-w-3xl">
        <div className="eyebrow text-bronze mb-2">Disclaimer and Copyright Notice</div>
        <h1 className="font-serif text-4xl md:text-5xl text-ink leading-tight">Disclaimer</h1>

        <div className="mt-8 space-y-4 text-ink_soft/85 font-light leading-relaxed">
          <p>
            The information provided on {BRAND.name} is intended solely for educational purposes and does not
            constitute legal, financial, or professional advice. Viewers and audiences are advised to conduct
            their own due diligence or seek professional advice before making any real estate decisions.{" "}
            {BRAND.name} shall not be held liable for any consequences resulting from the use of the information
            contained on this website.
          </p>
          <p>
            Furthermore, we do not represent, warrant, or endorse the accuracy or reliability of any information
            displayed, uploaded, downloaded, or distributed through the site by any user or other third party.{" "}
            {BRAND.name} disclaims any liability for damages or losses, whether direct or indirect, that may arise
            from the use of or reliance on information contained on the site.
          </p>
          <p>
            All images, videos, illustrations, or other visual representations, including photographs, and
            showflat displays, are intended to portray only artistic impressions or decor suggestions and should
            not be regarded as representations of fact.
          </p>
        </div>

        <Section title="Copyright Notice">
          <p>
            All content on {BRAND.name}, including but not limited to text, images, videos, and illustrations, is
            protected by copyright law. Any reproduction, modification, distribution, transmission, republication,
            display, or performance of the content on this website is strictly prohibited without the express
            written permission of the site owner. All rights are reserved.
          </p>
          <p>© {year} {BRAND.name}. All rights reserved.</p>
        </Section>
      </div>
    </div>
  );
}
